import { AnalyticIdentifier } from '@common/neo.tax';

import { useAnalyticId } from '@neo.tax/shared';

interface ProfileFormIds {
  fullNameInputId: string;
  companyNameInputId: string;
  completeProfileId: string;
}

export const useProfileFormIds = (): ProfileFormIds => {
  const fullNameInputId = useAnalyticId(AnalyticIdentifier.ONBOARDING_FULL_NAME_INPUT);
  const companyNameInputId = useAnalyticId(AnalyticIdentifier.ONBOARDING_COMPANY_NAME_INPUT);
  const completeProfileId = useAnalyticId(AnalyticIdentifier.ONBOARDING_COMPLETE_PROFILE);
  return {
    fullNameInputId,
    companyNameInputId,
    completeProfileId,
  };
};
